import PropTypes from "prop-types";
import ContentArea from "../../../components/ContentArea/async.component";
import { SectionHeading } from "../../../components/Heading/component";

const Politics = ({ splitProps }) => {
    return (
        <>
            <div
                className="landingNewsSplit politicsLanding"
                data-testid="politics"
            >
                <ContentArea {...splitProps.featuredProps} />
                <SectionHeading text={`More CBC News`} />
                <ContentArea {...splitProps.moreContentProps} />
            </div>
        </>
    );
};

Politics.propTypes = {
    path: PropTypes.string,
    splitProps: PropTypes.object,
};

export default Politics;
